// @flow
import {Api} from '@wellstone-solutions/common';
import type {ApiResponseType} from '@wellstone-solutions/common';

// Legacy V1 documentation routes — org scoped in the path, REST API version.
// Kept alongside the V2 api (api.js) so the documentation_v2 flag can fall back
// to V1 during rollout. Remove this file when the flag is retired.
export const routes = {
  index: (orgId: string): string =>
    `/orgs/${orgId}/documentation/session-documentation`,
  detail: (orgId: string, id: string): string =>
    `/orgs/${orgId}/documentation/session-documentation/${id}`,
  pdf: (orgId: string, id: string): string =>
    `/orgs/${orgId}/documentation/session-documentation/${id}/pdf`,
  sessionTypes: (id: string): string =>
    `/orgs/${id}/documentation/session-service-types`,
};

export const create = async (
  orgId: string,
  sessionDocInput: Object,
): Promise<ApiResponseType<Object>> =>
  Api.Instance.current().post(routes.index(orgId), sessionDocInput);

export const update = async (
  orgId: string,
  id: string,
  sessionDocInput: Object,
): Promise<ApiResponseType<Object>> =>
  Api.Instance.current().put(routes.detail(orgId, id), sessionDocInput);

export const updateFields = async (
  orgId: string,
  id: string,
  sessionDocInput: Object,
): Promise<ApiResponseType<Object>> =>
  Api.Instance.current().patch(routes.detail(orgId, id), sessionDocInput);

export const get = async (
  orgId: string,
  id: string,
): Promise<ApiResponseType<Object>> =>
  Api.Instance.current().get(routes.detail(orgId, id));

export const getPDF = async (
  orgId: string,
  id: string,
): Promise<ApiResponseType<Object>> =>
  Api.Instance.current().get(routes.pdf(orgId, id));

export const getServiceTypes = async (
  orgId: string,
): Promise<ApiResponseType<Array<Object>>> =>
  Api.Instance.current().get(routes.sessionTypes(orgId));

export const remove = async (
  orgId: string,
  id: string,
): Promise<ApiResponseType<{}>> =>
  Api.Instance.current().delete(routes.detail(orgId, id));
